module.exports = __webpack_public_path__ + "static/img/img7.f80de5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partnerLogo/img7.png
// module id = zreU
// module chunks = 1